import { Button, Group, Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/store/auth';
import { noteActivity, endSession } from '@/lib/session';

/**
 * Avertissement avant la déconnexion pour inactivité.
 *
 * Une session qui se ferme sans prévenir donne l'impression d'une panne, et
 * fait perdre ce qui était en cours de saisie. Une minute d'avance suffit à
 * lever la main — ou à finir sa phrase.
 *
 * Cliquer « Je suis là » compte comme une activité : le minuteur repart, et le
 * prochain renouvellement de jeton suivra tout seul.
 */
export function IdleWarning() {
  const { t } = useTranslation();
  const seconds = useAuth((s) => s.idleWarning);
  const signedIn = useAuth((s) => s.accessToken != null || s.refreshToken != null);

  if (seconds == null || !signedIn) return null;

  return (
    <Modal
      opened
      onClose={() => noteActivity()}
      title={t('session.idleTitle')}
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
    >
      <Text size="sm" mb="md">
        {t('session.idleBody', { count: seconds })}
      </Text>
      <Group justify="flex-end">
        <Button variant="subtle" onClick={() => endSession('user')}>
          {t('session.logoutNow')}
        </Button>
        <Button onClick={() => noteActivity()}>{t('session.stayConnected')}</Button>
      </Group>
    </Modal>
  );
}
